export default "__VITE_ASSET__DomjiKHX__"